export const adFormats = {
    POPUNDER: 'popunder',
    BANNER: 'banner',
    NATIVE_AD: 'native-ad',
    DIRECT_LINK: 'direct-link',
    IN_STREAM_AD: 'in-stream-ad',
    GALLERY: 'gallery',
    INTERSTITIAL: 'interstitial',
    IN_PAGE_AD: 'in-page-ad',
    WEB_PUSH: 'web-push',
    IOS_CALENDAR: 'ios-calendar'
}
